import { Dialog, DialogProps } from 'ui-kit';

import { DealRole } from '__generated__/globalTypes';
import { CloseButton, CompactDialogContainer } from './commonStyles';
import { FileDiligenceStatus, FileStatusDropdown } from './FileStatus';

import { GetDealDiligence } from 'query/__generated__/diligence';
type GetDealDiligence_deal_diligence_collateral = NonNullable<
  NonNullable<NonNullable<NonNullable<GetDealDiligence>['deal']>['diligence'][number]>['collateral']
>[number];
interface QuickStatusDialogProps {
  loanName: string;
  collateral: GetDealDiligence_deal_diligence_collateral[];
  dialog: DialogProps;
  role: DealRole;
  onStatusChange: (
    dealId: string,
    loanId: string,
    fileName: string,
    status: FileDiligenceStatus,
  ) => void;
}

export const QuickStatusDialog = ({
  dialog,
  collateral,
  loanName,
  role,
  onStatusChange,
}: QuickStatusDialogProps) => {
  const isSeller = role === DealRole.SELLER;

  return (
    <Dialog dialog={dialog} contentComponent={CompactDialogContainer}>
      <h1 className="relative mx-0 mb-2.5 mt-3px p-0 font-heebo text-xs font-medium leading-4 tracking-normal text-muted-gray">
        {isSeller ? 'View Documents Status' : 'View/Edit Documents Status'} for "{loanName}"
        <CloseButton onClick={() => dialog.setIsOpen(false)} />
      </h1>
      <div>Total: {collateral.length} Documents</div>
      <div className="flex flex-col gap-5px">
        {collateral.map((collateral) => (
          <div
            key={collateral.collateralID}
            className="flex items-center justify-between gap-5px font-heebo text-sm font-normal leading-4"
          >
            <div className="w-140px overflow-hidden text-ellipsis whitespace-nowrap font-heebo text-sm font-normal leading-4">
              {collateral.fileName}
            </div>
            <div style={{ width: '220px' }}>
              {collateral.collateralStatus && (
                <FileStatusDropdown
                  isInSelectedRow={false}
                  value={collateral.collateralStatus}
                  borderColor="#616161"
                  isDisabled={isSeller}
                  onChange={(status) =>
                    collateral.loanID &&
                    onStatusChange(
                      collateral.dealID,
                      collateral.loanID,
                      collateral.fileName,
                      status,
                    )
                  }
                />
              )}
            </div>
          </div>
        ))}
      </div>
    </Dialog>
  );
};
